import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { ViewMode } from "@/elements/documentViewer/DocumentViewer";
import { CollapseDocumentIcon, ExpandDocumentIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { checkIsDocumentViewer } from "../checkIsDocumentViewer";

interface UseDocumentModeButton {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useDocumentModeButton({
    setActiveSubMenu,
}: UseDocumentModeButton): MenuOptionResult {
    const { t } = useTranslation();
    const options = useAtomValue(
        widgetMenuOptionsByNameAtom("documentMode"),
    ) as widgetOption<ViewMode>[];

    const mode = options[0].value;

    const handleClick = () => {
        setActiveSubMenu(null);

        const selectedEntities = canv.canvasController.selected;

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && checkIsDocumentViewer(child)) {
                child.switchViewMode();
            }
        }
    };

    const content = mode === "compact" ? <ExpandDocumentIcon /> : <CollapseDocumentIcon />;
    const tippyContent = mode === "compact" ? t("widgetMenu.expand") : t("widgetMenu.collapse");

    return {
        content,
        handleClick,
        tippyContent,
    };
}
